import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
const TARGET_USERS = [
    {
        icon: '🐾',
        iconBgColor: 'bg-amber-100',
        title: 'ペットの記録',
        quote: '「最近よく吐く気がする」',
        description: 'でも「気がする」だけで、本当に増えてる？',
        examplesLabel: 'こんな記録に',
        examples: [
            '吐き戻し',
            'ワクチン',
            'トリミング',
            '通院',
            'フィラリア薬'
        ]
    },
    {
        icon: '🌱',
        iconBgColor: 'bg-emerald-100',
        title: 'メンテナンスの記録',
        quote: '「最後に掃除したのいつ？」',
        description: '気づいた時には、もうホコリだらけ。',
        examplesLabel: 'こんな記録に',
        examples: [
            'フィルター掃除',
            'オイル交換',
            '水やり',
            '電池交換'
        ]
    },
    {
        icon: '💊',
        iconBgColor: 'bg-pink-100',
        title: '体調管理',
        quote: '「症状はいつ頃から？」',
        description: '先生に聞かれて、曖昧にしか答えられない。',
        examplesLabel: 'こんな記録に',
        examples: [
            '頭痛・片頭痛',
            '服薬',
            '通院',
            '発作'
        ]
    },
    {
        icon: '🎯',
        iconBgColor: 'bg-indigo-100',
        title: 'シンプルを求める方',
        quote: '「連続記録が途切れました」',
        description: 'あの通知がストレスだった。続けなくていい。',
        examplesLabel: 'こんな方に',
        examples: [
            '入力が面倒',
            '続かなかった',
            'シンプルが好き'
        ]
    }
];
const TargetUserCard = ({ user })=>{
    const [isExpanded, setIsExpanded] = useState(false);
    const handleToggle = ()=>setIsExpanded(!isExpanded);
    return /*#__PURE__*/ _jsxs("div", {
        role: "button",
        tabIndex: 0,
        className: `group relative w-90 cursor-pointer rounded-2xl bg-white p-7 text-center transition-all duration-300 ${isExpanded ? '' : 'hover:-translate-y-1 hover:shadow-xl'}`,
        onClick: handleToggle,
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleToggle();
            }
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: `mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full text-3xl ${user.iconBgColor}`,
                children: user.icon
            }),
            /*#__PURE__*/ _jsx("h3", {
                className: "mb-4 text-xl font-bold text-gray-900",
                children: user.title
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mb-2 text-lg leading-relaxed font-semibold text-gray-700",
                children: user.quote
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "mb-5 text-sm leading-relaxed whitespace-nowrap text-gray-500",
                children: user.description
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: `inline-flex items-center gap-1 rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 ${isExpanded ? 'bg-teal-600 text-white' : 'bg-teal-50 text-teal-600 group-hover:bg-teal-600 group-hover:text-white'}`,
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: `transition-transform duration-300 ${isExpanded ? 'rotate-45' : ''}`,
                        children: "＋"
                    }),
                    "活用例を見る"
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: `overflow-hidden text-left transition-all duration-300 ${isExpanded ? 'mt-5 max-h-52 opacity-100' : 'max-h-0 opacity-0'}`,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "mb-2 text-xs font-semibold tracking-wide text-gray-400 uppercase",
                        children: user.examplesLabel
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex flex-wrap gap-2",
                        children: user.examples.map((example)=>/*#__PURE__*/ _jsx("span", {
                                className: "rounded-full bg-gray-100 px-3 py-1.5 text-sm text-gray-700",
                                children: example
                            }, example))
                    })
                ]
            })
        ]
    });
};
const TargetUser = ()=>{
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-gray-100 px-4 py-24",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "mx-auto",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "mb-12 text-center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            className: "mb-2 text-3xl font-bold text-gray-900 md:text-4xl",
                            children: "こんな経験、ありませんか？"
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-base text-gray-500",
                            children: "Histotimeが役立つシーン"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-wrap items-start justify-center gap-6",
                    children: TARGET_USERS.map((user, index)=>/*#__PURE__*/ _jsx(TargetUserCard, {
                            user: user
                        }, index))
                })
            ]
        })
    });
};
export default TargetUser;
